import { useTranslation } from 'react-i18next';
import React from 'react';
import { Coins, Landmark, Globe, BarChart3, Shield, TrendingUp, RefreshCw } from 'lucide-react';

const iconMap = {
  crypto: <Coins className="w-5 h-5 text-emerald-500" />,
  stocks: <Landmark className="w-5 h-5 text-blue-400" />,
  forex: <Globe className="w-5 h-5 text-amber-400" />,
  etfs: <BarChart3 className="w-5 h-5 text-cyan-400" />,
  intangibles: <Shield className="w-5 h-5 text-purple-400" />,
};

const titleMap = {
  crypto: 'Crypto Markets',
  stocks: 'US Equities',
  forex: 'Forex',
  etfs: 'ETFs & Indices',
  intangibles: 'IP Assets (IntangiHub)',
};

export function MarketPrices({ data, type, loading: isLoading }) {
  const { t } = useTranslation();
  const entries = data ? Object.entries(data) : [];

  return (
    <div className="bg-[#090B0F] border border-white/10 p-4" data-testid={`market-prices-${type}`}>
      <div className="flex items-center gap-2 mb-4">
        {iconMap[type] || <TrendingUp className="w-5 h-5 text-emerald-500" />}
        <h3 className="text-sm uppercase tracking-[0.2em] font-semibold text-white">{titleMap[type] || 'Markets'}</h3>
        {entries.length > 0 && (
          <span className="ml-auto text-[10px] font-mono text-slate-500">
            {entries[0]?.[1]?.source === 'yfinance' ? 'LIVE' : entries[0]?.[1]?.source === 'mock' ? 'MOCK' : 'LIVE'}
          </span>
        )}
      </div>
      {isLoading ? (
        <div className="flex items-center justify-center py-8">
          <RefreshCw className="w-5 h-5 text-slate-500 animate-spin" />
        </div>
      ) : entries.length === 0 ? (
        <p className="text-slate-500 text-xs py-4 text-center font-mono">{t('dashboard.noDataAvailable')}</p>
      ) : (
        <div className="space-y-1">
          {entries.slice(0, 8).map(([symbol, info]) => (
            <div key={symbol} className="flex items-center justify-between py-2 border-b border-white/5 last:border-0 hover:bg-[#11141D] px-1 transition-colors">
              <div className="flex items-center gap-2">
                <span className="font-mono text-white text-sm font-medium">{symbol}</span>
              </div>
              <div className="text-right">
                <p className="font-mono text-white text-sm">
                  {type === 'crypto' ? '$' : type === 'forex' ? '' : '$'}
                  {typeof info?.price === 'number'
                    ? (info.price > 1000
                      ? info.price.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })
                      : info.price > 10
                        ? info.price.toFixed(2)
                        : info.price.toFixed(4))
                    : (info?.price_usd?.toLocaleString() || '\u2014')}
                </p>
                <p className={`font-mono text-xs ${(info?.change_24h ?? 0) >= 0 ? 'text-emerald-400' : 'text-red-400'}`}>
                  {(info?.change_24h ?? 0) >= 0 ? '+' : ''}{(info?.change_24h ?? 0).toFixed(2)}%
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
